import Component from '../../../shared/component';
import RemoteReloadingElement from '../../../shared/components/remote-reloading-element';

const MAX_ROW = 5;

export default class GroupsTable extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$contentElement = this.$element.find('table tbody');
    this.$button = this.$element.find('.groupsTable-button');

    this.isFetchingNextGroups = false;
    this.shouldFetchNextGroups = true;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$button.on('click.GroupsTable', this.handleClick);
  }

  unbindEvents() {
    this.$button.off('click.GroupsTable', this.handleClick);

    if (this.remoteReloadingElements) {
      this.remoteReloadingElements.forEach((element) => element.unbindEvents());
    }
  }

  fetchNextGroups() {
    this.isFetchingNextGroups = true;

    const $lastGroupElement = this.$contentElement
      .find('.groupsTable-table-row')
      .last();

    if ($lastGroupElement.length) {
      let data = {until: $lastGroupElement.data('last-activity-at')};

      if (!data.until) {
        // eslint-disable-next-line camelcase
        data = {updated_before: $lastGroupElement.data('updated-at')};
      }

      $.get(this.$element.attr('action'), data).done((data) =>
        this.handleNextGroupsSuccess(data)
      );
    } else {
      this.isFetchingNextGroups = false;
    }
  }

  reapplyComponentBehavior() {
    this.remoteReloadingElements = RemoteReloadingElement.initialize(
      this.$element.find('.remoteReloadingElement')
    );
  }

  appendNextGroups(html) {
    this.$contentElement.append(html);
    this.reapplyComponentBehavior();

    const rowsCount = this.$contentElement.find('.groupsTable-table-row')
      .length;
    if (rowsCount < MAX_ROW || rowsCount % MAX_ROW) {
      this.$button.hide();
      this.shouldFetchNextGroups = false;
    }
  }

  handleClick() {
    if (this.shouldFetchNextGroups && !this.isFetchingNextGroups) {
      this.fetchNextGroups();
    }
  }

  handleNextGroupsSuccess(data) {
    if (String(data).trim() !== '') {
      this.appendNextGroups(data);
    } else {
      // We’ve reached the bottom of the list, stop trying to fetch messages
      this.$button.hide();
      this.shouldFetchNextGroups = false;
    }

    this.isFetchingNextGroups = false;
  }
}
